<template>
    <div class="container-fluid">
        <div class="col-md-12">
            <h2>Attended Auctions</h2>
            <div>
                <auction-sites></auction-sites>
            </div>
        </div>
    </div>
</template>
<script>
    import AuctionSites from './Forms/AuctionSites'
    export default {
        created() {
        },
        components: {
            'auction-sites': AuctionSites
        },
        data() {
            return {
            }
        },
        computed: {
        },
        methods: {
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/AuctionSitesPage.vue